import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import SearchSection from "@/components/SearchSection";
import ListingsGrid from "@/components/ListingsGrid";
import { fetchListings, type ListingFilters } from "@/lib/listings";

interface Props {
  /** Optional initial filters (e.g. neighborhood of the current page). */
  initialFilters?: ListingFilters;
}

/**
 * "Encontre Seu Imóvel Ideal" search block, reusable on listing and
 * neighborhood pages. Keeps its own filter state and results grid.
 */
const PropertySearchSection = ({ initialFilters = {} }: Props) => {
  const [filters, setFilters] = useState<ListingFilters>(initialFilters);
  const [searched, setSearched] = useState(false);

  const { data: listings = [], isLoading } = useQuery({
    queryKey: ["listings-search-block", filters],
    queryFn: () => fetchListings(filters),
  });

  return (
    <div className="pt-14 bg-background">
      <div className="[&>section]:mt-0">
        <SearchSection
          onSearch={(f) => {
            setFilters({ ...initialFilters, ...f });
            setSearched(true);
          }}
        />
      </div>
      {searched && <ListingsGrid listings={listings} isLoading={isLoading} />}
    </div>
  );
};

export default PropertySearchSection;
